import React,  { useState, useEffect } from "react"
import * as motion from "motion/react-client"
import "./fluid-avatar.scss"

interface AvatarProps {
    volume: number; // Volume value passed from SidePanel
  }
const FluidAvatar: React.FC<AvatarProps> = ({ volume }) => {
    // const [scale, setScale] = useState(1);
    const normalizedVolume = Math.max(0, Math.min(100, volume*250));
    const baseBarHieght = 50;
    const [barOne, setBarOne] = useState(baseBarHieght);
    const [barTwo, setBarTwo] = useState(baseBarHieght);
    const [barThree, setBarThree] = useState(baseBarHieght);
    const [barFour, setBarFour] = useState(baseBarHieght);
    // console.log(volume, scale, "outside--->>")
    useEffect(()=>{
        // if (volume > 0.01){
        //     setScale(2 + volume);
        // }
        // else {
        //     setScale(1);
        // }
        // console.log(scale, volume);
        if (normalizedVolume < 25 && normalizedVolume > 1){
            setBarOne(baseBarHieght + normalizedVolume)
        }
        else if (normalizedVolume > 25 && normalizedVolume < 50){
            setBarTwo(baseBarHieght + normalizedVolume)
        }
        else if (normalizedVolume > 50 && normalizedVolume < 75){
            setBarThree(baseBarHieght + normalizedVolume)
        }
        else if (normalizedVolume > 75){
            setBarFour(baseBarHieght + normalizedVolume)
        }
        else {
            setBarOne(baseBarHieght)
            setBarTwo(baseBarHieght)
            setBarThree(baseBarHieght)
            setBarFour(baseBarHieght)
        }

    }, [normalizedVolume])
    // const ball = {
    //     width: "13vw",
    //     height: "13vw",
    //     backgroundColor: "#dd00ee",
    //     borderRadius: "50%",
    // }
    // return (
    //     // <div style={{position: "relative", top: "50%", left: "50%", width: "20vw", height: "20vw"}}>
    //         <motion.div
    //             // initial={{ opacity: 1, scale: 10 }}
    //             animate={{ opacity: 1, scale: scale }}
    //             transition={{
    //                 duration: 0.4,
    //                 scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
    //             }}
    //             style={ball}
    //         />
    //     // </div>
    // )
    // const barSpacing = 10; // Space between bars
    const totalStateArray = [barOne, barTwo, barThree, barFour]
    return (
        <div
          className="animation-wrapper"
        >
            {totalStateArray.map((value, index) => {
                return (<motion.div
                key={index}
                initial={{ height: baseBarHieght }} // Start with base height
                animate={{ height: value }} // Animate to dynamic height
                transition={{ duration: 0.5}} // Smooth transition with staggered delay
                className="animation-bar"
              />)
            })}
        </div>
      );
}

export default FluidAvatar;